var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdiona(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0732 0H33.0492L7.29492 52L0 48.6432L24.0732 0Z",
    fill: "url(#paint0_linear_191_26376)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7571 2.73685L29.377 11.6397L48.855 51.0877L55.9999 47.7605L33.7571 2.73685Z",
    fill: "url(#paint1_linear_191_26376)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 33.7544C16.3955 33.7544 6.16 39.5956 0 48.5771L7.06221 52C12.8489 47.4465 20.0977 42.3591 28 42.3591C35.8711 42.3591 43.1511 47.4465 48.9067 51.9687L48.9377 52L56 48.5456C49.8399 39.5956 39.6044 33.7544 28 33.7544Z",
    fill: "url(#paint2_linear_191_26376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_26376",
    x1: 6,
    y1: 144.588,
    x2: 32.673,
    y2: -6.02032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_191_26376",
    x1: 105.5,
    y1: 112.292,
    x2: 43.6125,
    y2: -5.78654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_191_26376",
    x1: -41,
    y1: 77.0144,
    x2: 60.9242,
    y2: 51.3727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0065DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdiona);
export default __webpack_public_path__ + "static/media/adiona.4cbfb936443a5c6aed1a12c84f9f6cc5.svg";
export { ForwardRef as ReactComponent };